import { AbstractControl } from '@angular/forms';

import { REGEX_EMAIL } from '../constants';

export const emailValidator = (control: AbstractControl): { [key: string]: boolean } | null => {
    if (!control.value.match(REGEX_EMAIL)) {
        return { email: true };
    }

    return null;
};
